export default function checkWhitespace(text) {
    if(text === '' || text.match(/^ *$/) !== null) {
        return true;
    }
    return false;
}